// extracted by mini-css-extract-plugin
export default {"root":"BeamSelectionControl_root__9e4xC","label":"BeamSelectionControl_label__b8aER","input":"BeamSelectionControl_input__JFCt5"};